import { BigNumber } from '@0x/utils'
import _chainConfigs from './chains'
import * as gasConfig from './gasConfig'
import _links from './links'
import routeConfig from './routeConfig'
import { DEX } from 'app-lib/dexSelector/types'
import { ChainId as _ChainId } from './chains/chainCommon'
export { stakingConfig, daoConfig } from './chains/ethereumConfig'
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const MAX_UINT = new BigNumber(2).pow(256).minus(1)
export const INFINITE_ALLOWANCE = MAX_UINT
export const links = _links

export const supportedChains: ChainId[] = [1, 10, 56, 137, 42161]
export type ChainId = _ChainId

/**
 * The localstorage key used to store whether the user has seen that he is not allowed to trade
 * see InfoBlock in <App />
 */
export const acceptNoTradeKey = 'notAllowedToTrade'

/**
 * Amount of time that needs to have passed for all vbzrx to have vested (after cliff)
 * @see https://github.com/OokiTrade/contractsV2/blob/2ee66ab40eff103441cad040452f6ed06f197520/contracts/staking/StakingConstants.sol#L33
 */
const vestingDurationAfterCliff = 110376000
const INITIAL_TORQUE_LOAN_DURATION = new BigNumber(7884000) // initialLoanDuration (approximately 3 months)

export enum UdfFeed {
  BINANCE = 'BINANCE',
  KYBER = 'KYBER',
}

const udfFeeds: Record<UdfFeed, { id: UdfFeed; url: string; symbolSeparator: string }> = {
  BINANCE: { id: UdfFeed.BINANCE, url: 'https://api.ooki.com/udf/56', symbolSeparator: '' },
  KYBER: { id: UdfFeed.KYBER, url: 'https://api.kyber.network/chart', symbolSeparator: '_' },
}

/**
 * default delay for a debounced function 250ms
 */
const delay = 250

export const gas = gasConfig

export const ookiToken = {
  address: {
    1: '0x0de05f6447ab4d22c8827449ee4ba2d5c288379b',
    137: '0xcd150b1f528f326f5194c012f32eb30135c7c2c9',
  },
  slp: {
    address: '0xeaadde1e14c587a7fb4ba78ea78109bb32975f1e',
    blockExplorerUrl: 'https://etherscan.io/token/0xeaadde1e14c587a7fb4ba78ea78109bb32975f1e',
    sushiPoolLink: 'https://app.sushi.com/add/ETH/0x0de05f6447ab4d22c8827449ee4ba2d5c288379b',
  },
  iooki: {
    address: '0x05d5160cbc6714533ef44ced6dd32112d56ad7da',
    blockExplorerUrl: 'https://etherscan.io/token/0x05d5160cbc6714533ef44ced6dd32112d56ad7da',
  },
}

export const chainConfigs = _chainConfigs
export const bscCompensationContract = '0xcd5788E81821500cc306378E079B34b964876E55'
export const defaultLeverage = { stablePair: 7, others: 3 }
export const routes = routeConfig
export const maxLeverage = { stablePair: 15, others: 5 }
export const leverageSliderMarks = {
  stablePair: [1, 3, 5, 7, 9, 11, 13, 15],
  others: [1, 2, 3, 4, 5],
}

interface IDexDetails {
  name: string
  spriteLogo: string
  appLink?: string
}

export const dexDetails: Record<DEX, IDexDetails> = {
  [DEX.SUSHI]: {
    name: 'Sushi',
    spriteLogo: 'token-sushi',
    appLink: 'https://app.sushi.com/',
  },
  [DEX.AUTO]: {
    name: 'Auto',
    spriteLogo: '',
  },
  [DEX.UNISWAPV3]: {
    name: 'Uni v3',
    spriteLogo: 'uniswap',
    appLink: 'https://app.uniswap.org/',
  },
}

export const isChainSupported = (chain: number | ChainId) => {
  return supportedChains.includes(chain as ChainId)
}

export function getBlockExplorerAddressLink(chainId: ChainId, address: string) {
  const { blockExplorer } = chainConfigs[chainId].chainDetails
  return `${blockExplorer}/address/${address}`
}

export const themes = {
  light: { bgDefault: '#fff' },
  dark: { bgDefault: '#1e2024' },
}

export default {
  maxLeverage,
  bscCompensationContract,
  chainConfigs,
  defaultLeverage,
  delay,
  dexDetails,
  gas,
  INFINITE_ALLOWANCE,
  INITIAL_TORQUE_LOAN_DURATION,
  links,
  MAX_UINT,
  routes,
  udfFeeds,
  vestingDurationAfterCliff,
  ZERO_ADDRESS,
}
